<template>
  <b-modal
    ref="export-modal"
    id="export_wallet"
    centered
    hide-header
    hide-footer
    modal-class="mobile-modal"
    size="lg">
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="$bvModal.hide('export_wallet')"
      >×</button>
      <div class="pt-5 px-md-3 pb-md-3">
        <h3 class="color-navy-blue mb-4">Export statement</h3>
          <b-form>
            <b-form-group>
              <b-form-input
                id="input-1"
                v-model="fileName"
                type="email"
                placeholder="Enter File Name"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <select class="custom-select" v-model="selectedFormat">
                <option selected disabled :value="null">Please select an option</option>
                <option value="xlsx">xlsx</option>
                <option value="csv">csv</option>
                <option value="txt">txt</option>
              </select>
            </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox" switch name="checkbox" size="lg" v-model="cellAutoWidth">
              Auto width cells
            </b-form-checkbox>
          </b-form-group>
            <b-row>
              <b-col md="6" order-md="2">
                <b-button @click.prevent="exportToExcel()" type="submit" variant="custom" pill block class="mb-3" :disabled="!selectedFormat">Export</b-button>
              </b-col>
              <b-col md="6">
                <b-button
                  type="button"
                  variant="outline-custom"
                  pill
                  block
                  class="mb-3"
                  @click="$bvModal.hide('export_wallet')"
                >Cancel</b-button>
              </b-col>
            </b-row>
          </b-form>
      </div>
  </b-modal>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // Exports Settings
      fileName: '',
      cellAutoWidth: true,
      selectedFormat: null,
      headerTitle: ['Type', 'Date', 'Time', 'Sender / Recipient', 'Reference', 'Ledger', 'Method', 'Currency', 'Amount'],
      headerVal: ['payment_type', 'date', 'time', 'user', 'reference', 'ledger', 'payment_method', 'currency', 'amount'],
      exportData: [],
      activePrompt: false
    }
  },
  methods: {
    exportToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.exportData
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    },
    formatData (data) {
      data.forEach(record => {
        var item = {
          payment_type: record.payment_type,
          date: moment(record.session.date_stamp).format('YYYY-MM-DD'),
          time: moment(record.session.date_stamp).format('HH:mm:ss'),
          user: this.formatUser(record),
          reference: record.reference,
          ledger: record.ledger,
          payment_method: record.payment_method,
          currency: record.currency,
          amount: record.amount
        }
        this.exportData.push(item)
      })
    },
    formatUser (data) {
      if (data.payment_type === 'Debit' && data.ledger === 'Truzo Fees') {
        return 'Truzo'
      } else if (data.payment_type === 'Credit' && data.sender) {
        return this.$options.filters.formatUser(data.sender)
      } else if (data.payment_type === 'Credit' && data.sender_company) {
        return data.sender_company.name
      } else if (data.payment_type === 'Debit' && data.recipient) {
        return this.$options.filters.formatUser(data.recipient)
      } else if (data.payment_type === 'Debit' && data.recipient_company) {
        return data.recipient_company.name
      } else {
        return ''
      }
    },
    clearFields () {
      this.filename = ''
      this.selectedFormat = null
    }
  },
  created () {
    this.formatData(this.records)
  },
  watch: {
    records (val) {
      if (!val) return
      this.exportData = []
      this.formatData(val)
    }
  }
}
</script>
